export enum CreditRoutes {
  Credit = 'credit',
  Design = 'design',
  Portfolio = 'portfolio',
  Structure = 'structure',
  Metrics = 'metrics',
  Group = 'group',
  Compare = 'compare',
  PricingCurve = 'pricingcurve',
  Tower = 'tower',
  CashFlows = 'cash-flows',
  PortfolioExploration = 'portfolio-exploration',
  AnimatedScenarios = 'animated-scenarios',
  Stratifications = 'stratifications',
  Performance = 'performance',
  Submission = 'submission',
  Monitoring = 'monitoring',
  Quote = 'quote',
  NoAccess = 'no-access',
}

const STRUCTURE_PATH = `${CreditRoutes.Portfolio}/:portfolioId/${CreditRoutes.Structure}/:structureId`

export const CREDIT_PATHS = {
  Design: CreditRoutes.Design,
  EmptyTower: CreditRoutes.Tower,
  Tower: `${STRUCTURE_PATH}/${CreditRoutes.Tower}`,
  CashFlows: `${STRUCTURE_PATH}/${CreditRoutes.CashFlows}`,
  PortfolioExploration: `${STRUCTURE_PATH}/${CreditRoutes.PortfolioExploration}`,
  AnimatedScenarios: `${STRUCTURE_PATH}/${CreditRoutes.AnimatedScenarios}`,
  Stratifications: `${STRUCTURE_PATH}/${CreditRoutes.Stratifications}`,
  Performance: `${STRUCTURE_PATH}/${CreditRoutes.Performance}`,
  Group: CreditRoutes.Group,
  Compare: CreditRoutes.Compare,
  Metrics: CreditRoutes.Metrics,
  PricingCurve: CreditRoutes.PricingCurve,
  Submission: CreditRoutes.Submission,
  Monitoring: CreditRoutes.Monitoring,
  Quote: CreditRoutes.Quote,
  NoAccess: CreditRoutes.NoAccess,
}

export const CREDIT_CONTEXT_PATHS = {
  Design: [CreditRoutes.Credit, CreditRoutes.Design],
  Group: [CreditRoutes.Credit, CreditRoutes.Group],
  Compare: [CreditRoutes.Credit, CreditRoutes.Compare],
  Metrics: [CreditRoutes.Credit, CreditRoutes.Metrics],
  PricingCurve: [CreditRoutes.Credit, CreditRoutes.PricingCurve],
  Submission: [CreditRoutes.Credit, CreditRoutes.Submission],
  Monitoring: [CreditRoutes.Credit, CreditRoutes.Monitoring],
  Quote: [CreditRoutes.Credit, CreditRoutes.Quote],
} as const

export const MI_CONTEXT_PATHS = {
  Design: [CreditRoutes.Credit, 'mi', CreditRoutes.Design],
  Group: [CreditRoutes.Credit, 'mi', CreditRoutes.Group],
  Compare: [CreditRoutes.Credit, 'mi', CreditRoutes.Compare],
  Metrics: [CreditRoutes.Credit, 'mi', CreditRoutes.Metrics],
  PricingCurve: [CreditRoutes.Credit, 'mi', CreditRoutes.PricingCurve],
  Submission: [CreditRoutes.Credit, 'mi', CreditRoutes.Submission],
  Monitoring: [CreditRoutes.Credit, 'mi', CreditRoutes.Monitoring],
  Quote: [CreditRoutes.Credit, 'mi', CreditRoutes.Quote],
} as const

export const GSE_CONTEXT_PATHS = {
  Design: [CreditRoutes.Credit, 'gse', CreditRoutes.Design],
  Group: [CreditRoutes.Credit, 'gse', CreditRoutes.Group],
  Compare: [CreditRoutes.Credit, 'gse', CreditRoutes.Compare],
  Metrics: [CreditRoutes.Credit, 'gse', CreditRoutes.Metrics],
  PricingCurve: [CreditRoutes.Credit, 'gse', CreditRoutes.PricingCurve],
  Submission: [CreditRoutes.Credit, 'gse', CreditRoutes.Submission],
  Monitoring: [CreditRoutes.Credit, 'gse', CreditRoutes.Monitoring],
  Quote: [CreditRoutes.Credit, 'gse', CreditRoutes.Quote],
} as const

export enum CreditModuleContext {
  Design = 'DESIGN',
  Group = 'GROUP',
  GseGroup = 'GSE_GROUP',
  Compare = 'COMPARE',
  GseCompare = 'GSE_COMPARE',
  Metrics = 'METRICS',
  PricingCurve = 'PRICING_CURVE',
  Submission = 'SUBMISSION',
  Monitoring = 'MONITORING',
  Quote = 'QUOTE',
}
